<template lang="pug">
  div
    v-dialog(v-model="confirmation" persistent max-width="480")
      v-card
        title-bar(dark) {{confirmTitle}}
        v-card-text {{confirmMessage}}
        v-card-actions
          v-spacer
          v-btn(flat @click="doDismiss") Yes
          v-btn.primary(@click="confirmation = false") No
    v-navigation-drawer.slider(
      v-show="!hideDrawer"
      temporary
      stateless
      fixed
      hide-overlay
      :right="slideFromRight"
      :value="isDrawerOpen"
      :style="styles"
      ref="slider"
      :width="width"
      :height="height"
      :class="{ 'attach-to-bottom': attachToBottom }"
    )
      .slider-container
        .slider-title
          v-toolbar.pl-0(fixed dark flat color='primary lighten-1' prominent)
            v-toolbar-title(data-cy="slider-titlebar")
              v-icon(v-if="draggable" @mousedown="dragMouseDown" @dblclick="resetDragPosition").draggable drag_indicator
              slot(name="title")
            v-spacer
            v-btn.mr-0.pr-0(
              :disabled="isSavingAdAccounts"
              @click="handleDismiss"
              data-cy="slider-close-btn"
              flat
              icon
              large
              ref="closer"
              )
              v-icon(white) close
        .slider-content
          slot(name="content")
        div(v-if="hasActionsCustomSlot")
            slot(name="actionsCustom")
        .slider-actions.justify-end(v-else)
            v-btn(flat color="primary" @click="handleDismiss" v-show="defaultCancel" :disabled="isSavingAdAccounts") Cancel
            slot(name="actions")

</template>

<script>
import { mapState } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';

export default {
  components: {
    TitleBar,
  },
  data() {
    return {
      confirmation: false,
      clientX: undefined,
      clientY: undefined,
      movementX: 0,
      movementY: 0,
      hideDrawer: true,
      isDrawerOpen: false,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true,
    },
    confirmDismiss: {
      type: Boolean,
      default: false,
    },
    confirmTitle: {
      type: String,
      default: 'Discard Changes?',
    },
    confirmMessage: {
      type: String,
      default: 'Are you sure you want to discard your changes?',
    },
    slideFromRight: {
      type: Boolean,
      default: true,
    },
    defaultCancel: {
      type: Boolean,
      default: true,
    },
    additionalStyles: {
      type: String,
    },
    height: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: '640'
    },
    attachToBottom: {
      type: Boolean,
      default: false,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$refs.slider.$el.querySelector('.slider-container').addEventListener("transitionend", (event) => { event.stopPropagation() });
    this.$refs.slider.$el.addEventListener("transitionend", () => { if (!this.isDrawerOpen) this.hideDrawer = true });
  },
  computed: {
    ...mapState({
      isSavingAdAccounts: state => state.facebookBusiness.isSavingAdAccounts,
    }),
    styles() {
      if (this.value) {
        return this.additionalStyles;
      }
    },
    hasActionsCustomSlot() {
      return !!this.$slots['actionsCustom'] || !!this.$scopedSlots['actionsCustom'];
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) this.hideDrawer = false;
        setTimeout((val) => { this.isDrawerOpen = val }, 50, val);
      },
      immediate: true,
    },
  },
  methods: {
    handleDismiss() {
      if (this.confirmDismiss) {
        this.confirmation = true;
      } else {

        this.doDismiss();
      }
    },
    doDismiss() {
      this.confirmation = false;
      this.resetDragPosition();
      this.$emit('input', false);
      // scroll client component to top, if applicable
      this.$refs.slider.$el.querySelector('.slider-content').scrollTop = 0;
    },
    dragMouseDown(event) {
      event.preventDefault()
      this.clientX = event.clientX
      this.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },
    elementDrag(event) {
      event.preventDefault()
      this.movementX = this.clientX - event.clientX
      this.movementY = this.clientY - event.clientY
      this.clientX = event.clientX
      this.clientY = event.clientY
      this.$refs.slider.$el.style.top = (this.$refs.slider.$el.offsetTop - this.movementY) + 'px'
      this.$refs.slider.$el.style.left = (this.$refs.slider.$el.offsetLeft - this.movementX) + 'px'
    },
    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    },
    resetDragPosition () {
      this.clientX = undefined;
      this.clientY = undefined;
      this.movementX = 0;
      this.movementY = 0;
      this.$refs.slider.$el.style.top = null;
      this.$refs.slider.$el.style.left = null;
    }
  },
};
</script>

<style lang="scss" scoped>
  .attach-to-bottom {
    bottom: 0;
    top: auto;
  }
  .draggable {
    cursor: move;
  }
</style>